import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// route-level code splitting
const HomeView = () => import('../views/HomeView.vue')
const HealthCheck = () => import('../views/HealthCheck.vue')
const PrivacyView = () => import('../views/PrivacyView.vue')
const TosView = () => import('../views/TosView.vue')
const AboutView = () => import('../views/AboutView.vue')
const InstructionView = () => import('../views/InstructionView.vue')
const RecoverInstructionView = () => import('../views/RecoverInstructionView.vue')
const GuidelineView = () => import('../views/GuidelineView.vue')
const UserView = () => import('../views/UserView.vue')
const PollGamesView = () => import('../views/PollGamesView.vue')
const QuestionView = () => import('../views/QuestionView.vue')
const QuizView = () => import('../views/QuizView.vue')
const ConversationsView = () => import('../views/ConversationsView.vue')
const SchoolsView = () => import('../views/SchoolsView.vue')
const SchoolPostView = () => import('../views/SchoolPostView.vue')
const PostView = () => import('../views/PostView.vue')
const RoomInviteView = () => import('../views/RoomInviteView.vue')
const EventInviteView = () => import('../views/EventInviteView.vue')
const SchoolShareView = () => import('../views/SchoolShareView.vue')
const FriendInvitationView = () => import('../views/FriendInvitationView.vue')
const DelUsrDataView = () => import('../views/DelUsrDataView.vue')
const ModerationView = () => import('../views/ModerationView.vue')
const ModerationFullView = () => import('../views/ModerationFullView.vue')
const ModerationVideoView = () => import('../views/ModerationFullView-Video.vue')
const ReportView = () => import('../views/ModerationReportView.vue')
export function createRouter () {
  return new Router({
    mode: 'history',
    fallback: false,
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      { path: '/', component: HomeView },
      { path: '/health-check', component: HealthCheck },
      { path: '/tos', component: TosView },
      { path: '/about', component: AboutView },
      { path: '/guidelines', component: GuidelineView },
      { path: '/privacy', component: PrivacyView },
      // { path: '/user/:id', component: UserView }, 
      { path: '/chat/*', component: HomeView},
      { path: '/poll-games/:code', component: PollGamesView},
      { path: '/questions/:qid', component: QuestionView},
      { path: '/quizzes/:qid', component: QuizView},
      { path: '/conversations/:id', component: ConversationsView},
      { path: '/schools/:id', component: SchoolsView},
      { path: '/schools/:cid/posts/:pid', component: SchoolPostView},
      { path: '/posts/:pid', component: PostView},
      { path: '/invitations', component: FriendInvitationView },
      { path: '/room-invite/:rid', component: RoomInviteView },
      { path: '/event-invite/:rid', component: EventInviteView },
      { path: '/school-share/:rid', component: SchoolShareView },
      { path: '/instruction', component: InstructionView},
      { path: '/recover-instruction', component: RecoverInstructionView},
      { path: '/delUsrData', component: DelUsrDataView},
      { path: '/moderation/full', component: ModerationFullView},
      { path: '/moderation/v3e_f', component: ModerationVideoView},
      { path: '/moderation', component: ModerationView},
      { path: '/report', component: ReportView},
      { path: '/:handle', component: UserView },
    ]
  })
}



// WEBPACK FOOTER //
// src/router/index.js